import { useDecisionMakerProfilePageFcm } from 'src/app/pages/decisionMakerProfile/pageContext';

type Result = ModelHookResult<
	{
		email: string;
		phone: string;
		emailHref: string;
	},
	undefined
>;

export function useContactDetails(): Result {
	const { dmResponsivenessScoreConfig } = useDecisionMakerProfilePageFcm();

	const emailHref = `mailto:${dmResponsivenessScoreConfig.contact.email}`;

	return {
		data: {
			email: dmResponsivenessScoreConfig.contact.email,
			phone: dmResponsivenessScoreConfig.contact.phone,
			emailHref,
		},
	};
}
